export default __webpack_public_path__ + "static/media/ic-practice-test.2fd9809a.svg";